import { createSelector } from 'reselect';
import { selectors as profileSelectors } from '@clearscore/redux.profile';

import getRoutesByStage from './routesStagesSelector';

const getRouteByIDVStatus = (state) => {
    const { accountIDVStatus = 'CREATE_ACCOUNT', failureReason } = profileSelectors.getStatus(state);
    const routes = getRoutesByStage(state, failureReason || accountIDVStatus);
    return routes[0] || {};
};

export default createSelector(getRouteByIDVStatus, (route) => ({
    route,
}));
